import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const OrganizationDocumentsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
OrganizationDocumentsViewTopBar.displayName = "OrganizationDocumentsViewTopBar"
